module.exports = __webpack_public_path__ + "media/img/favicon/favicon-32x32-a4fdf3cb43c0b015a8d88b1f7e59b2d5.png";